import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import type { LocationBoxPlacement } from "../LocationLayout/types";
import { locationBoxAnchor } from "../LocationRun/anchor";
import type { LocationRun } from "../LocationRun/runs";

/** Stage-space stack origin (time-based; not camera zoom). */
export function locationStackStagePosition(
  layout: BookTimelineLayout,
  run: LocationRun,
  placement: LocationBoxPlacement,
  playheadMs: number,
  viewportWidth: number,
): { anchorX: number; topY: number } {
  return locationBoxAnchor(
    layout,
    run,
    placement,
    playheadMs,
    viewportWidth,
  );
}
